import { Card } from '@client/new/components/Card';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import { action, errorTip, iconWrapper, iconColumn } from './ErrorTip.css';

export const ErrorTip = (
  p: React.PropsWithChildren & { title: string; action: React.ReactNode },
) => (
  <Card variant="basic" withoutBg rounded="lg" className={errorTip}>
    <Col className={iconColumn}>
      <div className={iconWrapper}>
        <FontAwesomeIcon color="#DA0000" icon={faExclamationCircle} />
      </div>
    </Col>
    <Col>
      <Row>
        <Typography variant="body" size="large" fontWeight="medium">
          {p.title}
        </Typography>
        <div className={action}>{p.action}</div>
      </Row>

      <Typography variant="body" fontWeight="normal">
        {p.children}
      </Typography>
    </Col>
  </Card>
);
